module.exports = __webpack_public_path__ + "static/media/Alien (Series 3).c609d9cd.jpg";